<template>
    <table class="table mb-0">
        <thead>
        <tr>
            <th>ID</th>
            <th>Nickname</th>
            <th>Amount</th>
            <th>Trial Days</th>
            <th>Active</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="plan of plans" :key="plan.id">
            <td>{{ plan.id }}</td>
            <td>{{ plan.nickname }}</td>
            <td>
                <div v-if="plan.billing_scheme !== 'tiered'"><span>{{ (plan.amount / 100) | currency }}
/ {{ plan.interval | interval(plan.interval_count) }}</span></div>
                <div v-if="plan.billing_scheme === 'tiered'"><span>Starts at {{ (plan.tiers[0].amount / 100) | currency }}
per unit / {{ plan.interval | interval(plan.interval_count) }}
up to {{ plan.tiers[0].up_to }} unit</span></div>
            </td>
            <td><span v-if="plan.trial_period_days">{{ plan.trial_period_days }}</span><span class="text-muted"
                                                                                             v-if="!plan.trial_period_days">(undefined)</span>
            </td>
            <td>
                <toggle-button class="mb-0" v-model="plan.active" disabled="disabled"></toggle-button>
            </td>
        </tr>
        </tbody>
    </table>
</template>

<script>
    export default {
        props: {
            plans: {required: true, type: Array},
        },
    };
</script>
